import { render, staticRenderFns } from "./RangeColorCreateEdit.vue?vue&type=template&id=0e4c290d"
import script from "./RangeColorCreateEdit.vue?vue&type=script&lang=js"
export * from "./RangeColorCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports